const Accordion = () => {

    document.addEventListener('DOMContentLoaded', function () {
        const accordionButtons = document.querySelectorAll('.accordion-button');

        accordionButtons.forEach(button => {
            button.addEventListener('click', function () {
                const target = document.querySelector(this.getAttribute('data-target'));

                // Toggle the display of the target element
                if (target.classList.contains('hidden')) {
                    target.classList.remove('hidden');
                    target.classList.add('block');
                    this.setAttribute('aria-expanded', 'true');
                } else {
                    target.classList.remove('block');
                    target.classList.add('hidden');
                    this.setAttribute('aria-expanded', 'false');
                }

                // Hide all other accordion contents
                document.querySelectorAll('.accordion-collapse').forEach(collapse => {
                    if (collapse !== target) {
                        collapse.classList.remove('block');
                        collapse.classList.add('hidden');
                    }
                });

                // Update the button states
                accordionButtons.forEach(btn => {
                    if (btn !== this) {
                        btn.setAttribute('aria-expanded', 'false');
                    }
                });
            });
        });
    });

};

export default Accordion;
